module.exports = __webpack_public_path__ + "img/closed-loop-8.e9b607ff.png";